import { UserDto } from "./User";


export class RoleDto {
    id!: string;
    name!: string;
    projectId!: string;
}

export class RolesDto{
    pageSize!: number;
    totalCount!: number;
    roles!: RoleDto[];
}

export class RoleResolved {
    roleDto!: RoleDto;
    error?:any;    
}


export class SquirrelSelectItemDto {
    id!: string;
    text!: string;
}

export class UserRoleDto {
    userId!: string;
    roleId!: string;
}

export class UserRolesDto {
    userId!: string;
    roleId!: string;
    name!: string;
    pageSize!: number;
    totalCount!: number;
    roles!: RoleDto[];
    rolesList!: SquirrelSelectItemDto[];
}



export class ProjectRoleDto {
    projectId!: string;
    roleId!: string;
}

export class ProjectRolesDto{
    projectId!: string;
    roleId!: string;
    name!: string;
    pageSize!: number;
    totalCount!: number;
    rolesList!: SquirrelSelectItemDto[];
    projectRoles!: ProjectRoleDto[];
}

export class ProjectGroupRoleUser {
    projectId!:string;
    userId!:string;
    roleId!:string;
    roleName!:string;
    userName!:string;
    tenantId!:string;
}

export class SelectUserpermissionsResult {
    userData!: any;
    projRolePairs!:string[];
}

